import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { IRole } from '@metutors/core/models';
import * as fromCore from '@metutors/core/state';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '@metutors/core/services';
import { Affiliate, SocialProvider } from '@metutors/config';
import { RolesSelectComponent } from '@metutors/shared/components';
import { Input, OnInit, Output, Component, EventEmitter } from '@angular/core';

@Component({
  selector: 'metutors-signup-modal',
  templateUrl: './signup-modal.component.html',
  styleUrls: ['./signup-modal.component.scss'],
})
export class SignupModalComponent implements OnInit {
  error$: Observable<string>;
  roles$: Observable<IRole[]>;
  userType$: Observable<number>;
  userRole$: Observable<number>;
  affiliate$: Observable<string>;
  isLoading$: Observable<boolean>;
  authLoading$: Observable<boolean>;

  @Input() title: string;
  @Input() returnUrl: string;
  @Input() showModal: boolean = false;

  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() signinClicked: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    private _store: Store<any>,
    private _dialog: MatDialog,
    private _route: ActivatedRoute,
    private _authService: AuthService
  ) {}

  ngOnInit(): void {
    this._prepareRoles();
    this._store.dispatch(fromCore.resetRegisterError());
    this.error$ = this._store.select(fromCore.selectSignUpError);
    this.isLoading$ = this._store.select(fromCore.selectIsSignUp);
    this.affiliate$ = this._store.select(fromCore.selectAffiliate);
    this.userType$ = this._store.select(fromCore.selectRegisterUserType);
    this.authLoading$ = this._store.select(fromCore.selectIsSocialSignIn);
  }

  onRegister(user: any): void {
    this._store.dispatch(fromCore.register({ user, isModal: true }));
  }

  changeStep(step: number, email: string, userType: number): void {
    this._store.dispatch(
      fromCore.registerStep({
        step,
        email,
        userType,
      })
    );
  }

  openRolesDialog(domain: any, roles: IRole[]): void {
    const _dialogRef = this._dialog.open(RolesSelectComponent, {
      width: '500px',
      disableClose: true,
      data: roles,
    });

    _dialogRef.afterClosed().subscribe(res => {
      if (res && res.data) {
        const userType = res.data.toString();

        this.changeStep(1, '', +userType!);
        domain === 'google'
          ? this.signInWithGoogle(userType)
          : this.signInWithFacebook(userType);
      }
    });
  }

  signInWithGoogle(userType: number) {
    this._authService
      .signInWithGoogle()
      .then((response: any) => {
        const data = {
          ...response,
          role: userType,
          provider: SocialProvider.google,
          affiliate:
            this._route.snapshot.queryParams['affiliate'] || Affiliate.normal,
        };

        this._store.dispatch(
          fromCore.socialSignIn({ user: data, returnUrl: this.returnUrl })
        );
      })
      .catch((error: any) => console.log('Error =>', error));
  }

  signInWithFacebook(userType: number) {
    this._authService.signInWithFacebook().then(response => {
      const data = {
        ...response,
        role: userType,
        provider: SocialProvider.facebook,
        affiliate:
          this._route.snapshot.queryParams['affiliate'] || Affiliate.normal,
      };

      this._store.dispatch(
        fromCore.socialSignIn({ user: data, returnUrl: this.returnUrl })
      );
    });
  }

  private _prepareRoles(): void {
    this._store.dispatch(fromCore.loadUserTypes());
    this.roles$ = this._store.select(fromCore.selectUserTypes);
  }
}
